import React from "react";
import ManagerNavbar from "../Layout/ManagerNavbar";
import EmailTemplatesPage from "../placement/EmailTemplatesPage";

export default function ManagerEmailTemplatesPage() {
  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <ManagerNavbar />
      <EmailTemplatesPage />
    </div>
  );
}
